module.exports = __webpack_public_path__ + "static/media/man-sitting-while-holding-his-hair-1892842.ad93b9f1.jpg";